import { createStore } from 'easy-peasy';

import { IStoreModel } from './types';
import { rootModel } from './rootModel';

const store = createStore<IStoreModel>(rootModel, {
  name: 'VelloHealthStore',
});

export default store;
